export const Loader = () => {
  return (
    <div className="fixed min-h-screen min-w-full bg-[#00000099] flex items-center justify-center z-20">
      <div className="w-32 h-32">
        <div className="border-box p-2 w-full h-full border-[10px] border-[#162534] border-t-[#4bc8eb] border-b-[#f13a8f] rounded-[50%] animate-rotate">
          <div className="border-box w-full h-full border-[10px] border-[#162534] border-t-[#4bc8eb] border-b-[#f13a8f] rounded-[50%] animate-rotate border-t-[#36f372] border-b-[#fff]"></div>
        </div>
      </div>
    </div>
  );
};
